import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { getWeillCornell } from "../../../../../state/selectors/CancerCurated.selectors";
import PMKBInternal from "./PMKBInternal";

const { arrayOf, shape, number, string, node } = PropTypes;
const PMKB = ({ result }) => {
  return <PMKBInternal result={result} isCollapsed={false} />;
};

const mapStateToProps = (state) => ({
  result: getWeillCornell(state),
});

PMKB.propTypes = {
  result: shape({
    version: string,
    items: arrayOf(
      shape({
        tier: number,
        definition: arrayOf(string),
        interpretations: string,
        tissues: arrayOf(string),
        tumour_types: arrayOf(string),
        disease_or_trait: node,
        pub_med_references: arrayOf(number),
        variants: arrayOf(
          shape({
            variants: arrayOf(string),
            type: string,
            definition: string,
            gene_id: number,
          })
        ),
      })
    ),
  }),
};

PMKB.defaultProps = {
  result: null,
};
export default connect(mapStateToProps)(PMKB);
